import {
  New,
  Expand,
  Upgrade,
  AudioVideo,
  CallCenter,
  CallHold,
  CallMonitor,
  CloudPhone,
  LinkingMultiple,
  MicrosoftTeam,
  MobileApps,
  RemoteWork,
  Unsure,
} from "../svg/phonesystem";
import RadioCircle from "../../svgs/radioCircle";
//Product Title
export const routeDetails = {
  title:"Let Us Find You The Best Business Phone System",
  q1: "/",
  q2: "/2",
  q3: "/3",
  form: "/6",
  thankyou: "/thankyou",
};

//Link Path
const firstRoute = "/phone-system/Questions/";
//1----2
const firstLink = "/phone-system/Questions/2";
//2----3
const secondLink = "/phone-system/Questions/3";
//3----Forms
const formLink = "/phone-system/Questions/6";
//Forms----Thanks
export const thanksLink = "/phone-system/Questions/thankyou";

// Question1
export const Que1Data = [
  {
    question: "Which best describes your phone system needs?",
    progress: 20,
    back: false,
    next: firstLink,
    options: [
      {
        answer: "Installing new phone system",
        to: firstLink,
        icon: New,
      },
      {
        answer: "Replacing existing phone system",
        to: firstLink,
        icon: Upgrade,
      },
      {
        answer: "Expanding existing phone system",
        to: firstLink,
        icon: Expand,
      },
    ],
  },
];
// Question2
export const Que2Data = [
  {
    question: "How many handsets or user extensions do you need?",
    progress: 40,
    back: firstRoute,
    next: secondLink,
    options: [
      {
        answer: "1-3",
        to: secondLink,
        icon: RadioCircle,
      },
      {
        answer: "4-10",
        to: secondLink,
        icon: RadioCircle,
      },
      {
        answer: "11-25",
        to: secondLink,
        icon: RadioCircle,
      },
      {
        answer: "26-50",
        to: secondLink,
        icon: RadioCircle,
      },
      {
        answer: "50+",
        to: secondLink,
        icon: RadioCircle,
      },
      {
        answer: "Not sure",
        to: secondLink,
        icon: RadioCircle,
      },
    ],
  },
];
// Question3
export const Que3Data = [
  {
    question: "What features do you require?",
    progress: 50,
    back: firstLink,
    next: formLink,
    options: [
      {
        answer: "Remote working ability",
        icon: RemoteWork,
      },
      {
        answer: "Cloud or hosted solutions",
        icon: CloudPhone,
      },
      {
        answer: "Microsoft team calling",
        icon: MicrosoftTeam,
      },
      {
        answer: "Linking multiple sites",
        icon: LinkingMultiple,
      },
      {
        answer: "On hold messages",
        icon: CallHold,
      },
      {
        answer: "Mobile phone or desktop apps",
        icon: MobileApps,
      },
      {
        answer: "Contact or call centre",
        icon: CallCenter,
      },
      {
        answer: "Call monitoring or recording",
        icon: CallMonitor,
      },
      {
        answer: "Audio or video conferencing",
        icon: AudioVideo,
      },
      {
        answer: "Unsure, please advise",
        icon: Unsure,
      },
    ],
  },
];

//Admin email template.
export const adminEmailTemplate = ({
  fullname,
  email,
  companyName,
  phoneNumber,
  postcode,
  ans1,
  ans2,
  ans3,
  ans4,
  ans5,
}) => {
  return `<h1>Lead genrated for: Business Phone System</h1><br>
        <h4>Customer Details</h4><br>
        <ul>
        <li>Full name: <b>${fullname}</b></li><br>
        <li>Email: <b>${email}</b></li><br>
        <li>Company name: <b>${companyName}</b></li><br>
        <li>Phone number: <b>${phoneNumber}</b></li><br>
        <li>Postcode: <b>${postcode}</b></li><br>
        </ul>
        <p>1.Which best describes your phone system needs?:<br><b>${ans1}</b></p><br>
        <p>2.How many handsets or user extensions do you need?:<br><b>${ans2}</b></p><br>
        <p>3.What features do you require?:<br> <b>${ans3}</b></p><br>
        <p>4.Has Your Business Moved To The NBN Yet?:<br><b>${ans4}</b></p><br>
        <p>5.When Are You Likely To Buy A Phone System?:<br><b>${ans5}</b></p>`;
};
